import { render, staticRenderFns } from "./AppContentContainerFullWidth.vue?vue&type=template&id=732a0036&"
import script from "./AppContentContainerFullWidth.vue?vue&type=script&lang=js&"
export * from "./AppContentContainerFullWidth.vue?vue&type=script&lang=js&"
import style0 from "./AppContentContainerFullWidth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports